import axios from 'axios';
import store from 'store';
import Swal from 'sweetalert2';
// import { DataTable } from "simple-datatables";


import authHelper from './helpers/authHelper.js';
import { axiosErrorHandler, axiosResponseHandler, callTheBaseServerGet, callTheBaseServerPost } from './helpers/axiosHelper.js';
import { addDNoneClass, btnLoading, byId } from './helpers/utility.js';
authHelper.validate().then(async () => {






  //   let  last_profit_dat = byId('last_profit_dat');
  const submit_btn = byId('submit_btn');
  const edit_btn = byId('edit_btn');
  const yamasha_stock_price = byId('yamasha_stock_price');
  const yamasha_stock_gain = byId('yamasha_stock_gain');


  const yvsPageFun = {
    fetch: async () => {
      try {
        btnLoading(edit_btn, 'Fetching...', true);
        const response = await callTheBaseServerGet('/basic/getYvsData');
        axiosResponseHandler(response);
        btnLoading(edit_btn, 'Fetching...', false);
        const res = response.data;
        if (res.status === 'success') {
          console.log(res);

          const { yvsStockCurrentPrice, yvsStockPreviousPrice, priceChange, priceChangePercent, lastUpdatedAt } = res.yvsData;


          yamasha_stock_price.value = yvsStockCurrentPrice;
          yamasha_stock_gain.value = `${(priceChange > 0) ? '+' : ''}${priceChange}`;
        }


      } catch (error) {
        axiosErrorHandler(error);
      }
    },
    update: {
      init: () => {
        yamasha_stock_price.disabled = false;
       
        addDNoneClass(edit_btn, true);
        addDNoneClass(submit_btn, false);
      },
      submit: async () => {
        try {
          const data = {
            newPrice: yamasha_stock_price.value
          };
          const response = await callTheBaseServerPost('/basic/updateYvsData', { data });
          axiosResponseHandler(response);
          const res = response.data;
          if (res.status === 'success') {
            console.log(res);

            yamasha_stock_price.disabled = true;
           
            addDNoneClass(edit_btn, false);
            addDNoneClass(submit_btn, true);

            Swal.fire({
              icon: 'success',
              title: 'Stock Prize Updated',
    
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
    
            });

            yvsPageFun.fetch();
          }


        } catch (error) {
          axiosErrorHandler(error);
        }
      }
    }
  };
  window.yvsPageFun = yvsPageFun;
  yvsPageFun.fetch();
  

});









